var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hackReset)?_c('ejs-dialog',{ref:_vm.refName,attrs:{"target":_vm.target,"isModal":_vm.isModal,"width":_vm.width,"height":_vm.height,"minHeight":_vm.height,"header":_vm.header,"buttons":_vm.buttonGroup,"visible":_vm.visible,"beforeClose":_vm.clear,"showCloseIcon":_vm.closeIcon,"zIndex":_vm.zIndex}},[_vm._t("dialog-content")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }